module.exports = __webpack_public_path__ + "img/qr.71f3467a.png";